module.exports = __webpack_public_path__ + "fonts/FilsonPro-Black.119b125.eot";